module.exports = __webpack_public_path__ + "static/media/Eric O'Connor Head Shot.7ff24390.jpeg";